import { CheckOutlined } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { XButton } from "share-components/mui-wrap/button/x-button";
import { XProgressButton } from "share-components/mui-wrap/button/x-progress-button";

export const DeleteConfirmation = observer(() => {
  const {
    deleteConfirmationStore: { open, reset, deletionCallback },
  } = useStores();

  const onOkHandler = useCallback(async () => {
    await deletionCallback?.();
    reset();
  }, [deletionCallback, reset]);
  return (
    <Dialog open={open} fullWidth maxWidth={"xs"}>
      <DialogTitle component={Stack}>
        <Stack direction={"row"} spacing={1} alignItems={"center"}>
          <Box>Xác nhận</Box>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>Bạn chắc chắn muốn xóa dữ liệu ?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <XButton
          variant="text"
          // startIcon={<CancelOutlined></CancelOutlined>}
          onClick={() => reset()}
        >
          Hủy
        </XButton>
        <XProgressButton
          variant="outlined"
          startIcon={<CheckOutlined />}
          onClick={() => {
            onOkHandler();
          }}
        >
          Đồng ý
        </XProgressButton>
      </DialogActions>
    </Dialog>
  );
});
